<template>
  <div>
    <b-modal
      ref="modal-congrat"
      centered
      hide-footer
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @close="closeModal()"
    >
      <div class="d-flex flex-column text-center">
        <!-- picture/animation -->
        <div>
          <img src="@/assets/4life-logo-small.png" width="120px" />
        </div>

        <!-- congratulation -->
        <h3 class="modal-congrat__title font-weight-bold mt-3 mb-0">Congratulation</h3>

        <!-- congratulation detail -->
        <div class="modal-congrat__description mt-3">
          <div>On completing your Micro-Credential successfully.</div>
          <div>Download your badge or share it.</div>
        </div>

        <!-- accredible button -->
        <div class="modal-congrat__button mt-3 pt-3">
          <b-button
            variant="primary"
            :href="accredibleLink"
            :disabled="accredibleLink === null ? true : false"
          >
            View on Accredible
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Credential from '@/models/Credential';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },

    accredibleLink: {
      type: String,
      default: null
    },

    credentialId: {
      type: [Number, String],
      required: true
    }
  },

  mounted() {
    if (this.show === true) {
      this.$refs['modal-congrat'].show();
    }
  },

  methods: {
    closeModal() {
      this.updateLearnerSeeCredential();
    },

    async updateLearnerSeeCredential() {
      await Credential.api().update(this.credentialId);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .modal-backdrop {
  background-color: rgba(255, 255, 255, 0.8) !important;
}

::v-deep .modal-content {
  border: 1px solid rgba(7, 9, 25, 0.125);
  box-shadow: 0px 0px;
}

::v-deep .modal-header {
  border-bottom: 0px;
}

.modal-congrat__description {
  font-size: 13.81px;
  color: rgba(7, 9, 25, 0.5);
}

.modal-congrat__button {
  border-top: 1px solid #eeeff8;
}
</style>
